const BASE_URL = "https://www.dhanlaxmiurban.in/backend";
// const BASE_URL = "http://localhost/Dhanlaxmi/backend/";

export default BASE_URL;








